<script lang="ts">
  import { slide } from 'svelte/transition';

  const props: { error?: string } = $props();
</script>

{#if props.error}
  <p transition:slide class="validation-error">{props.error}</p>
{/if}

<style lang="scss">
  @use 'sass:color';
  @use '~/theme/theme';
  @use '~/theme/themify' as *;
  .validation-error {
    font-weight: bold;
    font-size: 0.75em;
    text-align: center;
    border-radius: 2px;
    margin: 0 0 0.5em 0;
    @include themify {
      color: themed('star-penalty');
    }
  }
</style>
